import validate from "/usr/src/app/content/n3-spas-cd969e63-6669-493f-92f6-471b789f1787/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-cd969e63-6669-493f-92f6-471b789f1787/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}